var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suggestionsPage"},[_vm._v("意见建议")])
}
var staticRenderFns = []

export { render, staticRenderFns }